var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"idr-mian-zhuanjia"}},[_c('h1',{staticClass:"help"},[_vm._v("该功能目前正在开发中...")])])}]

export { render, staticRenderFns }